module.exports = __webpack_public_path__ + "img/eg-12-01.30300717.jpg";